export default {
    FIN_OPERATION: [
        {
            TABLE: "FIN_OPERATION_BUY",
            ID_FIN_OPERATION_TYPE: 1
        },
        {
            TABLE: "FIN_OPERATION_SALE",
            ID_FIN_OPERATION_TYPE: 2
        }
    ],
    PAYMENT_ORDERS: [
        {
            TABLE: "PAYMENT_ORDERS_INCOMING",
            ID_INVOICE_TYPE: 1
        },
        {
            TABLE: "PAYMENT_ORDERS_OUTGOING",
            ID_INVOICE_TYPE: 2
        }
    ],
    OPERATION_SUB_DOC: [
        {
            TABLE: "OPERATION_SUB_DOC_AUTO",
            ID_OPERATION_TYPE: 1
        },
        {
            TABLE: "OPERATION_SUB_DOC_TRAIN",
            ID_OPERATION_TYPE: 2
        },
        {
            TABLE: "OPERATION_SUB_DOC_SEA",
            ID_OPERATION_TYPE: 3
        },
        {
            TABLE: "OPERATION_SUB_DOC_AIR",
            ID_OPERATION_TYPE: 4
        },
        {
            TABLE: "OPERATION_SUB_DOC_REPACKING",
            ID_OPERATION_TYPE: 5
        },
        {
            TABLE: "OPERATION_SUB_DOC_CUSTOMS",
            // у некоторых документов операций "Таможенное оформление"
            // ID_OPERATION_TYPE не равен 6, смотри lw-6062
            ID_DOC_PARENT_OPERATION_TYPE: 6
        },
        {
            TABLE: "OPERATION_SUB_DOC_FORWARD",
            ID_OPERATION_TYPE: 7
        }
    ],
    INVOICE: [
        {
            TABLE: "INVOICE_INCOMING",
            ID_INVOICE_TYPE: 1
        },
        {
            TABLE: "INVOICE_OUTGOING",
            ID_INVOICE_TYPE: 2
        },
        {
            TABLE: "INVOICE_INCOMING_MONEY",
            ID_INVOICE_TYPE: 3
        },

        {
            TABLE: "INVOICE_OUTGOING_MONEY",
            ID_INVOICE_TYPE: 4
        }
    ],
    FIN_OPERATION_ORDER_DOC_LINK: [
        {
            TABLE: "DOC_FIN_OPERATION_BUY",
            ID_FIN_OPERATION_TYPE: 1
        },
        {
            TABLE: "DOC_FIN_OPERATION_SALE",
            ID_FIN_OPERATION_TYPE: 2
        }
    ]
};
